module.exports = __webpack_public_path__ + "scoreboard-ss-c13133fc.jpg";